module.exports = __webpack_public_path__ + "record-player.d4cb5bf6accf03632a60.gif";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/record-player.gif
// module id = ../../../../../src/assets/images/record-player.gif
// module chunks = main